import React from 'react';
import Layout from '../components/Layout';

const Services = () => {
  return (
    <Layout>
      <h2>Dịch vụ</h2>
      <p>Đây là thông tin về các dịch vụ mà công ty Tân Trí cung cấp.</p>
    </Layout>
  );
};

export default Services;
